
import React from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import { DisabilityProduct } from "../../enums/DisabilityProduct";
import { useAuth } from "oidc-react";
import { EmployerFormValues } from "../../common/EmployerFormValues";
import { useFormikContext } from "formik";
import { getKeyByValue } from "../../enums/KeyFinder";
import RadioGroup from "../../structure/RadioGroup";
import { useCoverages } from "../../../hooks/useCoverages";

const Product = () => {
    const { values } = useFormikContext<EmployerFormValues>();
    const auth = useAuth();
    const user = auth?.userData;
    const signedIn = !!user;

    const policyNumber = values.policyNumber;
    const privacyId = values.privacyId;
    const dateLastWorked = values.dateLastWorked
    const relationship = values.relationship

    const { data: coveragesData } = useCoverages(policyNumber, privacyId, relationship, dateLastWorked, auth);
    const coverages = coveragesData?.findCoverages
    const shortTermDisability = coverages?.shortTermDisability;
    const longTermDisability = coverages?.longTermDisability;

    const allDisabilityProducts = [DisabilityProduct.SHORT_TERM_DISABILITY, DisabilityProduct.LONG_TERM_DISABILITY];
    let disabilityProducts = allDisabilityProducts
        .filter(product => !signedIn
            || (shortTermDisability && product === DisabilityProduct.SHORT_TERM_DISABILITY)
            || (longTermDisability && product === DisabilityProduct.LONG_TERM_DISABILITY))
    if(!disabilityProducts.length) {
        disabilityProducts = allDisabilityProducts;
    }

    return (
        <QuestionPanel headerText="Which disability product is your employee filing for?"
                       panelContent={
                           <RadioGroup id="product" label="Product" required={true} radioProps={
                               disabilityProducts.map(disabilityProduct => {
                                   const disabilityProductKey = getKeyByValue(DisabilityProduct, disabilityProduct)
                                   return {
                                       id: disabilityProductKey.replace(/_/g, '-').toLowerCase(),
                                       text: disabilityProduct
                                   }
                               })}/>
                       }>
        </QuestionPanel>
    )
};
export default Product;